// extracted by mini-css-extract-plugin
export default {"toggle":"SwhqbZ"};